var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallLogCount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.278,
    height: 26.167,
    viewBox: "0 0 27.278 26.167",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16226",
    "data-name": "Group 16226",
    transform: "translate(-242.822 -18.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12039",
    "data-name": "Path 12039",
    d: "M8.7,18.913,2.028,12.245a6.934,6.934,0,0,1-.283-9.5,2.033,2.033,0,0,1,1.7-.692,2.033,2.033,0,0,1,1.585.931L7.106,6.142A2.067,2.067,0,0,1,7,8.57a1.54,1.54,0,0,0,.116,2.049l3.206,3.207a1.541,1.541,0,0,0,2.049.116,2.067,2.067,0,0,1,2.428-.107l3.158,2.075A2.076,2.076,0,0,1,18.2,19.2a6.937,6.937,0,0,1-9.5-.284ZM2.657,3.557a5.713,5.713,0,0,0,.234,7.824L9.56,18.049a5.713,5.713,0,0,0,7.824.234.854.854,0,0,0-.1-1.353l-3.157-2.075a.839.839,0,0,0-1,.042,2.761,2.761,0,0,1-3.673-.209L6.251,11.483a2.762,2.762,0,0,1-.208-3.674.839.839,0,0,0,.041-1L4.01,3.655a.815.815,0,0,0-.653-.382l-.072,0A.812.812,0,0,0,2.657,3.557ZM15.8,11.687a.42.42,0,0,1,0-.6l4.7-4.716H18.975a.422.422,0,0,1,0-.843h2.542a.421.421,0,0,1,.421.421V8.5a.421.421,0,0,1-.842,0V6.973l-4.7,4.713a.42.42,0,0,1-.6,0ZM10.563,6.278a.421.421,0,0,1-.421-.422V3.315a.421.421,0,1,1,.842,0V4.838l4.7-4.713a.421.421,0,0,1,.3-.124.416.416,0,0,1,.3.123.421.421,0,0,1,0,.6l-4.7,4.716h1.527a.422.422,0,0,1,0,.843Z",
    transform: "translate(242.822 23.727)",
    fill: "rgb(130, 130, 130)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallLogCount);
export default __webpack_public_path__ + "static/media/callLogCount.9f8d33cbd4fb34502f1870f9454ea508.svg";
export { ForwardRef as ReactComponent };